import Box from "@mui/material/Box";

export function HorizontalScrollContainer({
  children,
  gap = 2,
}: {
  children: React.ReactNode;
  gap?: number;
}) {
  return (
    <Box
      overflow="auto"
      display="flex"
      sx={{
        scrollbarWidth: "thin",
        scrollbarColor: (theme) =>
          `${theme.palette.action.disabled} transparent`,
      }}
    >
      <Box width="max-content" display="flex" gap={gap} pb={1}>
        {children}
      </Box>
    </Box>
  );
}
